window.panda = {};
export default window.panda;
